import React from 'react';

export const Testimonials = () => {
  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-12">
          <h2 className="text-5xl font-extrabold text-navy mb-4">
            Customer Stories
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Hear what our satisfied customers have to say about their experience
          </p>
        </div>
      <div className="bg-purple-custom rounded-[3rem] p-16">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-gray-600 uppercase tracking-wide mb-4">
            TESTIMONIALS
          </p>
          <h2 className="text-5xl font-extrabold text-navy">
            What People Say<br />
            About Us.
          </h2>
        </div>

        <div className="bg-white rounded-[2rem] p-8 max-w-2xl mx-auto">
          <div className="flex items-start gap-6">
            <div className="w-16 h-16 bg-gray-300 rounded-full flex-shrink-0" />
            <div>
              <p className="text-lg text-gray-700 mb-6 italic">
                "Great service and support. The team was very helpful throughout the process!"
              </p>
              <div>
                <p className="font-bold text-navy">Aarav Mehta</p>
                <p className="text-sm text-gray-500">Delhi, India</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};
